import { ISearchService } from '../../types';
import HandleSearch from './methods/HandleSearch';
import GetFilters from './methods/GetFilters';
import GetProductResults from './methods/GetProductResults';
// import GetCmsContent from './methods/GetCmsContent';
import GetSwatchData from '../../helpers/GetSwatchData';

// If a user doesn't accept cookies don't generate sessionKey/customerKey, set notify = false, and don't send notifications
// Preview mode, if PREVIEW=true is passed then viewId=preview should be added

const Voyado: ISearchService = {
  methods: {
    handleSearch: HandleSearch,
    getFilters: GetFilters,
    getProductResults: GetProductResults,
    // Voyado TODO
    // getCmsContent: GetCmsContent,
    getSwatchData: GetSwatchData
  }
};

export default Voyado;
